import { gql } from '@apollo/client';

export const PREPARE_SALES_ORDER_ATTACHMENT_UPLOAD = gql`
  mutation PrepareSalesOrderAttachmentUpload(
    $orderId: String!
    $mimeType: String!
    $fileName: String!
  ) {
    prepareSalesOrderAttachmentUpload(
      orderId: $orderId
      mimeType: $mimeType
      fileName: $fileName
    ) {
      attachmentUid
      uploadUrl
    }
  }
`;
